import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from 'src/app/shared/material.module';
import { ProductOfferComponent } from './components/product-offer/product-offer.component';
import { ReactiveFormsModule } from '@angular/forms';
import { CategoryListModalComponent } from './components/category-list/category-list-modal.component';
import { ConfigImporterExporterComponent } from './config-importer-exporter/config-importer-exporter.component';
import { ForgotPasswordComponent } from './components/forgot-password/forgot-password.component';
import { ExportListComponent } from './components/export-list/export-list.component';
import { ExportConfirmComponent } from './components/export-confirm/export-confirm.component';
import { ConfirmDeleteComponent } from './components/confirm-delete/confirm-delete.component';
import { ConfirmacaoModalComponent } from './components/confirmacao-modal/confirmacao-modal.component';
import { TemplateNotificacaoComponent } from './components/template-notificacao/template-notificacao.component';
import { ModalDatasObrigacoesComponent } from '../admin/crud-datas-obrigacoes/modal-datas-obrigacoes/modal-datas-obrigacoes.component';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import {MatRadioModule} from '@angular/material/radio';
import { ModalResourceTypeComponent } from '../settings/clients-obligations/components/modal-resource-type/modal-resource-type.component';
import { BulkUpdatesDialogComponent } from './components/bulk-updates-dialog/bulk-updates-dialog.component'

@NgModule({
    declarations: [
        ProductOfferComponent,
        CategoryListModalComponent,
        ConfigImporterExporterComponent,
        ForgotPasswordComponent,
        ExportListComponent,
        ExportConfirmComponent,
        ConfirmDeleteComponent,
        ConfirmacaoModalComponent,
        TemplateNotificacaoComponent,
        BulkUpdatesDialogComponent,
    ],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        MaterialModule,
        MatAutocompleteModule,
        MatFormFieldModule,
        MatInputModule,
        MatRadioModule
    ],
    exports: [
        BulkUpdatesDialogComponent
    ],
    providers: []
})
export class ModalModule { }
